import(/* webpackMode: "eager", webpackExports: ["PlayerHeader"] */ "/app/apps/pickleball/src/modules/players/v2/header/PlayerHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerHeaderMobile"] */ "/app/apps/pickleball/src/modules/players/v2/header/PlayerHeaderMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationTabs"] */ "/app/apps/pickleball/src/modules/players/v2/navigation/NavigationTabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@pqina+pintura@8.95.3/node_modules/@pqina/pintura/pintura.css");
;
import(/* webpackMode: "eager", webpackExports: ["AdPlaceholder"] */ "/app/packages/ui/src/components/advertisements/freestar/components/AdPlaceholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomFreestarAd"] */ "/app/packages/ui/src/components/advertisements/freestar/components/CustomFreestarAd.tsx");
